export default __webpack_public_path__ + "static/media/dvameka-apm.f6d0d0fb.mp3";